export default __webpack_public_path__ + "static/media/speed.983faf87.webp";